import { useState } from "react";
import { FaLock, FaEye, FaEyeSlash, FaEnvelope, FaUserPlus } from "react-icons/fa";
import "./Auth.css";

function Login({ onCambiarVista }) {
  const [form, setForm] = useState({ email: "", password: "" });
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [focused, setFocused] = useState({ email: false, password: false });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleFocus = (field) => setFocused({ ...focused, [field]: true });
  const handleBlur = (field) => setFocused({ ...focused, [field]: false });

  const login = async () => {
    if (!form.email || !form.password) {
      alert("Debe ingresar correo y contraseña");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        "https://sindicato.sintrasecsalud.com/api/index.php?modulo=auth&accion=login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        }
      );

      if (!res.ok) {
        throw new Error("Respuesta inválida del servidor");
      }

      const data = await res.json();
      setLoading(false);

      if (data.primera_vez) {
        localStorage.setItem("emailTemp", data.email);
        onCambiarVista("cambiarPrimera");
        return;
      }

      if (data.success) {
        localStorage.setItem("rol", data.rol);
        localStorage.setItem("email", data.email);
        onCambiarVista("inicio");
      } else {
        alert(data.error || "Credenciales inválidas");
      }

    } catch (error) {
      setLoading(false);
      console.error(error);
      alert("Error de conexión con el servidor");
    }
  };

  return (
    <div className="auth-wrapper">
      {/* LADO IZQUIERDO - BRANDING */}
      <div className="auth-hero">
        <div className="auth-hero-content">
          <div className="auth-logo-badge">
            <div className="logo-circle">
              <span>S</span>
            </div>
          </div>

          <h1 className="auth-hero-title">
            SINTRA<br />SECSALUD
          </h1>

          <p className="auth-hero-subtitle">
            Comprometidos con la dignidad laboral del sector salud
          </p>

          <div className="auth-hero-features">
            <div className="feature-item">
              <div className="feature-icon">🛡️</div>
              <div>
                <h4>Defensa de Derechos</h4>
                <p>Protegemos tus garantías laborales</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🤝</div>
              <div>
                <h4>Negociación Colectiva</h4>
                <p>Fortalecemos tu voz sindical</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">⚖️</div>
              <div>
                <h4>Asesoría Jurídica</h4>
                <p>Te acompañamos en cada proceso</p>
              </div>
            </div>
          </div>
        </div>

        {/* Elementos decorativos */}
        <div className="auth-orb orb-1"></div>
        <div className="auth-orb orb-2"></div>
        <div className="auth-orb orb-3"></div>
      </div>

      {/* LADO DERECHO - FORMULARIO */}
      <div className="auth-form-side">
        <div className="auth-card">
          <div className="auth-header">
            <h2>Bienvenido</h2>
            <p>Inicia sesión para acceder a tu cuenta</p>
          </div>

          {/* EMAIL */}
          <div className={`auth-input-group ${focused.email || form.email ? 'focused' : ''}`}>
            <div className="auth-input-icon">
              <FaEnvelope />
            </div>
            <input
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              onFocus={() => handleFocus('email')}
              onBlur={() => handleBlur('email')}
              placeholder=" "
            />
            <label>Correo electrónico</label>
            <span className="input-border"></span>
          </div>

          {/* PASSWORD */}
          <div className={`auth-input-group ${focused.password || form.password ? 'focused' : ''}`}>
            <div className="auth-input-icon">
              <FaLock />
            </div>
            <input
              name="password"
              type={show ? "text" : "password"}
              value={form.password}
              onChange={handleChange}
              onFocus={() => handleFocus('password')}
              onBlur={() => handleBlur('password')}
              placeholder=" "
            />
            <label>Contraseña</label>
            <span
              className="password-toggle"
              onClick={() => setShow(!show)}
              title="Mostrar / Ocultar contraseña"
            >
              {show ? <FaEyeSlash /> : <FaEye />}
            </span>
            <span className="input-border"></span>
          </div>

          {/* LINK OLVIDÉ */}
          <div className="auth-options">
            <div
              className="auth-link"
              onClick={() => onCambiarVista("olvide")}
            >
              ¿Olvidaste tu contraseña?
            </div>
          </div>

          {/* BOTÓN */}
          <button
            onClick={login}
            className="auth-btn"
            disabled={loading}
          >
            <span>{loading ? "Ingresando..." : "Iniciar Sesión"}</span>
            <div className="btn-shine"></div>
          </button>

          {/* DIVIDER */}
          <div className="auth-divider">
            <span>¿No tienes cuenta?</span>
          </div>

          {/* BOTÓN REGISTRARSE */}
          <button
            className="auth-btn-secondary"
            onClick={() => onCambiarVista("formulario")}
          >
            <FaUserPlus /> Registrarse ahora
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;